export default function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/extent.js
// module id = 607
// module chunks = 0